export const ROLE_LABELS: Record<string, string> = {
  ADMIN: 'Admin',
  MARKETING: 'Marketing',
  HR: 'HR',
  BENEFICIARY: 'Beneficiary',
  INTEGRATION: 'Integration',
};

const ROLE_ORDER = Object.keys(ROLE_LABELS);

export const compareRoles = (a?: string, b?: string) => {
  if (!a && !b) {
    return 0;
  }
  if (!a) {
    return 1;
  }
  if (!b) {
    return -1;
  }
  const indexA = ROLE_ORDER.indexOf(a);
  const indexB = ROLE_ORDER.indexOf(b);
  if (indexA === -1 && indexB === -1) {
    return a.localeCompare(b);
  }
  if (indexA === -1) {
    return 1;
  }
  if (indexB === -1) {
    return -1;
  }
  return indexA - indexB;
};

export const ROLE_COLORS: Record<string, string> = {
  ADMIN: 'purple',
  MARKETING: 'magenta',
  HR: 'pink',
  BENEFICIARY: 'orange',
  INTEGRATION: 'cyan',
};

export const getRoleLabel = (role?: string) => {
  if (!role) {
    return '—';
  }
  return ROLE_LABELS[role] ?? role;
};

export const getRoleColor = (role?: string) => {
  if (!role) {
    return undefined;
  }
  return ROLE_COLORS[role] ?? 'default';
};
